import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-push-notification-alert',
  templateUrl: './push-notification-alert.component.html',
  styleUrls: ['./push-notification-alert.component.css']
})
export class PushNotificationAlertComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<PushNotificationAlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {}

}
